import React from 'react';

const TmBreathalyzer = (props: any) => {
    return (
        <svg viewBox="0 0 300 400" fill="none" xmlns="http://www.w3.org/2000/svg" width="36" height="36">
            {/* Mouthpiece tube */}
            <rect
                x="100"
                y="25"
                width="200"
                height="30"
                rx="10"
                stroke={props.stroke ?? "currentColor"}
                strokeWidth="20"
                fill="none"
            />

            {/* Main device body */}
            <rect
                x="20"
                y="60"
                width="220"
                height="320"
                rx="35"
                stroke={props.stroke ?? "currentColor"}
                strokeWidth="20"
                fill="none"
            />

            {/* Display screen */}
            <rect
                x="50"
                y="90"
                width="160"
                height="120"
                stroke={props.stroke ?? "currentColor"}
                strokeWidth="20"
                fill="none"
            />

            {/* Left button (ring) */}
            <circle
                cx="85"
                cy="280"
                r="25"
                stroke={props.stroke ?? "currentColor"}
                strokeWidth="20"
                fill="none"
            />

            {/* Right button (ring) */}
            <circle
                cx="175"
                cy="280"
                r="25"
                stroke={props.stroke ?? "currentColor"}
                strokeWidth="20"
                fill="none"
            />
        </svg>
    );
};

export default TmBreathalyzer;

